import { createFileRoute } from "@tanstack/react-router";
import { AdminVenueCandidatesTab } from "@/components/admin/pages/AdminVenueCandidatesTab";

export const Route = createFileRoute("/pulse-ops-x7k2/target-cities/candidates")({
  component: AdminVenueCandidatesTab,
});
